export const SuspenseTrigger = () => {
    throw new Promise(() => {});
};
